import React from 'react';
import Icon from '../../../components/AppIcon';
import { useNavigate } from 'react-router-dom';

const CommonCapabilitiesSection = () => {
  const navigate = useNavigate();

  const capabilities = [
    {
      id: 1,
      icon: "Network",
      title: "System-of-Systems Orchestration",
      description: "Coordinate agents, tools, and legacy systems as unified workflows"
    },
    {
      id: 2,
      icon: "Users",
      title: "Human-in-the-Loop Decision Making",
      description: "Approval gates and oversight for critical operations"
    },
    {
      id: 3,
      icon: "Cpu",
      title: "Hardware-Agnostic Edge Deployment",
      description: "Deploy anywhere—cloud, edge, or on-premises infrastructure"
    },
    {
      id: 4,
      icon: "Shield",
      title: "Secure, Real-Time Coordination",
      description: "Event-driven orchestration with resilience to network disruptions"
    }
  ];

  return (
    <section className="py-24 px-4 md:px-6 lg:px-8 border-t border-border">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <h2 className="text-2xl font-bold text-foreground mb-3 md:mb-4 lg:mb-5">
            COMMON CAPABILITIES ACROSS ALL INDUSTRIES
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-12 md:mb-16">
          {capabilities?.map((capability) => (
            <div
              key={capability?.id}
              className="bg-card border border-border rounded-lg p-6 md:p-7 hover:border-primary/50 transition-all duration-300"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-primary/10 flex items-center justify-center mb-4 md:mb-5">
                <Icon name={capability?.icon} size={24} color="var(--color-primary)" />
              </div>

              <h3 className="text-base md:text-lg font-semibold text-foreground mb-2 md:mb-3">
                {capability?.title}
              </h3>

              <p className="text-xs md:text-sm text-muted-foreground leading-relaxed">
                {capability?.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <h3 className="text-xl md:text-2xl font-bold text-foreground mb-4 md:mb-6">
            Explore Detailed Use Cases
          </h3>
          <p className="text-sm md:text-base text-muted-foreground max-w-3xl mx-auto mb-6 md:mb-8">
            See how Sleeve orchestrates intelligent systems in your industry with technical architectures, integration patterns, and deployment models.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => navigate('/use-cases/manufacturing')}
              className="px-6 py-3 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors duration-250"
            >
              Explore a Detailed Use Case
            </button>
            <button
              onClick={() => navigate('/contact')}
              className="px-6 py-3 border border-border text-foreground rounded-lg font-medium hover:bg-card transition-colors duration-250"
            >
              Request a Live Platform Demo
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommonCapabilitiesSection;